// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__DlySQ","alert":"SettungsInbox_alert__c9Yk1"};